import React from "react";
import { Redirect } from "react-router-dom";
import TrialRegister from "../components/Trial_Register";
import SalesConfirmation from "../components/SalesConfirmation";
import DemoRequestDetails from "../components/DemoRequestDetails";
import Login from "../components/Login";
import Logout from "../components/Logout";
import SessionExpired from "../components/SessionExpired";
import ForgetPwd from "../components/Authentication/ForgetPassword";
import PasswordResetPage from "../components/Authentication/PasswordResetPage";
import Users from "../components/Users";
import AccessDeniedPage from "../components/AccessDenied";

const authProtectedRoutes = [
  { path: "/details", component: DemoRequestDetails },
];

const adminRoute = [{ path: "/users", component: Users }];

const publicRoutes = [
  { path: "/sessionExpired", component: SessionExpired },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/reset-password", component: PasswordResetPage },
  { path: "/register", component: TrialRegister },
  { path: "/confirmation", component: SalesConfirmation },
  { path: "/login", component: Login },
  { path: "/logout", component: Logout },
  { path: "/access-denied", component: AccessDeniedPage},
  { path: "/", component: () => <Redirect to="/register" /> },
];

export { publicRoutes, authProtectedRoutes, adminRoute };
